import { Instance, SnapshotOut, types } from "mobx-state-tree"
import { CommonCode } from "../common-code/CommonCode";

/**
 * # Terms
 * 
 * Terms을 설명하세요.
 */
export const Terms = types
  .model("Terms")
  // --------------------------------------------------------------------------
  .props({
    termsSid: types.maybeNull(types.optional(types.number, 0)),
    termsType: types.maybeNull(types.optional(CommonCode, {})),
    cdssTypeCd: types.maybeNull(types.optional(CommonCode, {})),
    termsOrder: types.maybeNull(types.optional(types.number, 0)),
    essnYn: types.maybeNull(types.optional(types.string, "")),
    useYn: types.maybeNull(types.optional(types.string, "")),
    termsTitle: types.maybeNull(types.optional(types.string, "")),
    termsConts: types.maybeNull(types.optional(types.string, "")),
    regDt: types.maybeNull(types.optional(types.string, "")),
    regId: types.maybeNull(types.optional(types.number, 0)),
    updDt: types.maybeNull(types.optional(types.string, "")),
    updId: types.maybeNull(types.optional(types.number, 0)),
  })
  // --------------------------------------------------------------------------
  // MUTATEs ONLY! - 모델 상태를 변경
  // REQUESTs는 스토어 모델에 작성하세요.
  // ex) yarn gen model terms --store
  .actions((self) => ({
    /*
     * 여러 prop을 한번에 수정
     */
    setProps: (props: { [key: string]: any }) => {
      const newProps = { ...self, ...props } as ITerms;
      (Object.keys(newProps) as TTermsKeys[]).forEach((key) => {
        // @ts-ignore
        self[key] = newProps[key];
      });
    },
  }));

// --------------------------------------------------------------------------
type TTerms = Instance<typeof Terms>;
type TTermsSnapshot = SnapshotOut<typeof Terms>

export interface ITerms extends TTerms { }
export type TTermsKeys = keyof TTermsSnapshot & string;
export interface ITermsSnapshot extends TTermsSnapshot { }
export const createTerms = () =>
  types.optional(Terms, {} as TTerms);
